import { dew as _blockDew } from "../../errors/block.js";
import { dew as _transactionDew } from "../../errors/transaction.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _observeDew } from "../../utils/observe.js";
import { dew as _withRetryDew } from "../../utils/promise/withRetry.js";
import { dew as _stringifyDew } from "../../utils/stringify.js";
import { dew as _getBlockDew } from "./getBlock.js";
import { dew as _getTransactionDew } from "./getTransaction.js";
import { dew as _getTransactionReceiptDew } from "./getTransactionReceipt.js";
import { dew as _watchBlockNumberDew } from "./watchBlockNumber.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.waitForTransactionReceipt = void 0;
  const block_js_1 = _blockDew();
  const transaction_js_1 = _transactionDew();
  const getAction_js_1 = _getActionDew();
  const observe_js_1 = _observeDew();
  const withRetry_js_1 = _withRetryDew();
  const stringify_js_1 = _stringifyDew();
  const getBlock_js_1 = _getBlockDew();
  const getTransaction_js_1 = _getTransactionDew();
  const getTransactionReceipt_js_1 = _getTransactionReceiptDew();
  const watchBlockNumber_js_1 = _watchBlockNumberDew();
  async function waitForTransactionReceipt(client, {
    confirmations = 1,
    hash,
    onReplaced,
    pollingInterval = client.pollingInterval,
    timeout
  }) {
    const observerId = (0, stringify_js_1.stringify)(["waitForTransactionReceipt", client.uid, hash]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject) => {
      if (timeout) setTimeout(() => reject(new transaction_js_1.WaitForTransactionReceiptTimeoutError({
        hash
      })), timeout);
      const _unobserve = (0, observe_js_1.observe)(observerId, {
        onReplaced,
        resolve,
        reject
      }, emit => {
        const _unwatch = (0, getAction_js_1.getAction)(client, watchBlockNumber_js_1.watchBlockNumber, "watchBlockNumber")({
          emitMissed: true,
          emitOnBegin: true,
          poll: true,
          pollingInterval,
          async onBlockNumber(blockNumber_) {
            if (retrying) return;
            let blockNumber = blockNumber_;
            const done = fn => {
              _unwatch();
              fn();
              _unobserve();
            };
            try {
              if (receipt) {
                if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                done(() => emit.resolve(receipt));
                return;
              }
              if (!transaction) {
                retrying = true;
                await (0, withRetry_js_1.withRetry)(async () => {
                  transaction = await (0, getAction_js_1.getAction)(client, getTransaction_js_1.getTransaction, "getTransaction")({
                    hash
                  });
                  if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                }, {
                  delay: ({
                    count
                  }) => ~~(1 << count) * 200,
                  retryCount: 6
                });
                retrying = false;
              }
              receipt = await (0, getAction_js_1.getAction)(client, getTransactionReceipt_js_1.getTransactionReceipt, "getTransactionReceipt")({
                hash
              });
              if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
              done(() => emit.resolve(receipt));
            } catch (err) {
              if (transaction && (err instanceof transaction_js_1.TransactionNotFoundError || err instanceof transaction_js_1.TransactionReceiptNotFoundError)) {
                try {
                  replacedTransaction = transaction;
                  retrying = true;
                  const block = await (0, withRetry_js_1.withRetry)(() => (0, getAction_js_1.getAction)(client, getBlock_js_1.getBlock, "getBlock")({
                    blockNumber,
                    includeTransactions: true
                  }), {
                    delay: ({
                      count
                    }) => ~~(1 << count) * 200,
                    retryCount: 6,
                    shouldRetry: ({
                      error
                    }) => error instanceof block_js_1.BlockNotFoundError
                  });
                  retrying = false;
                  const replacementTransaction = block.transactions.find(({
                    from,
                    nonce
                  }) => from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                  if (!replacementTransaction) return;
                  receipt = await (0, getAction_js_1.getAction)(client, getTransactionReceipt_js_1.getTransactionReceipt, "getTransactionReceipt")({
                    hash: replacementTransaction.hash
                  });
                  if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                  let reason = "replaced";
                  if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) {
                    reason = "repriced";
                  } else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) {
                    reason = "cancelled";
                  }
                  done(() => {
                    emit.onReplaced?.({
                      reason,
                      replacedTransaction: replacedTransaction,
                      transaction: replacementTransaction,
                      transactionReceipt: receipt
                    });
                    emit.resolve(receipt);
                  });
                } catch (err_) {
                  done(() => emit.reject(err_));
                }
              } else {
                done(() => emit.reject(err));
              }
            }
          }
        });
      });
    });
  }
  exports.waitForTransactionReceipt = waitForTransactionReceipt;
  //# sourceMappingURL=waitForTransactionReceipt.js.map
  return exports;
}